/** Petites fonctions de formatage (horloge, durées, dates relatives), portées du mockup. */

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

/** `MM:SS` à partir de secondes (chronomètre d'enregistrement). */
export function fmtClock(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${pad(m)}:${pad(s)}`;
}

/** Durée lisible : « 42 s », « 3 min 05 ». */
export function fmtDur(sec: number): string {
  if (sec < 60) return `${Math.round(sec)} s`;
  const m = Math.floor(sec / 60);
  const s = Math.round(sec % 60);
  return `${m} min${s ? " " + pad(s) : ""}`;
}

const MOIS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

/** Date relative : « Aujourd'hui · 14:32 », « Hier · … », sinon « 5 mars · … ». */
export function fmtDate(ts: number): string {
  const d = new Date(ts);
  const now = new Date();
  const day = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diff = Math.round((today.getTime() - day.getTime()) / 86_400_000);
  const t = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  if (diff === 0) return `Aujourd'hui · ${t}`;
  if (diff === 1) return `Hier · ${t}`;
  return `${d.getDate()} ${MOIS[d.getMonth()]} · ${t}`;
}

const FR_DATE = new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

/** Date locale `AAAA-MM-JJ` → libellé français (« lundi 18 mai 2026 »). */
export function fmtLocalDate(ymd: string): string {
  const [y, m, d] = ymd.split("-").map(Number) as [number, number, number];
  return FR_DATE.format(new Date(y, m - 1, d, 12));
}

/** Forme d'onde décorative (barres pseudo-aléatoires) pour les notes vocales sans données réelles. */
export function makeWaveform(n = 38): number[] {
  return Array.from({ length: n }, (_, i) => {
    const v = 0.28 + Math.abs(Math.sin(i * 1.7) * 0.5) + Math.random() * 0.35;
    return Math.min(1, v);
  });
}
